<template>
  <section>
    <Title
      :title-name="title.VirtualHelpdesk.titleName"
      :title-link="title.VirtualHelpdesk.titleLink"
      name-page="VirtualHelpdesk"
    />
    <div v-if="lang && lang['virtual_helpdesk'] && airline" class="virtual-helpdesk">
      <div class="container">
        <form class="page-virtual-helpdesk" style="margin: 14pt 0" @submit.prevent="confirmName()">
          <div>
            <div class="block block-message">
              <h4 class="font-weight-bold">{{ lang['virtual_helpdesk'].SFS_LANG_ROW_2 }},</h4>
              <p v-if="!confirmPax">
                {{ lang['virtual_helpdesk'].SFS_LANG_ROW_18 }}
              </p>
              <p v-if="confirmPax">
                {{ lang['virtual_helpdesk'].SFS_LANG_ROW_33 }}
              </p>
            </div>
            <div v-if="!confirmPax" class="block block-form-result-flight">
              <div class="font-weight-bold pt-3">Phone number: {{ pax.phone_number }}</div>
              <div class="pt-3 pb-3">
                <label for="first-name-check">First name</label>
                <!-- Fix bug SFS-2132 LHG I1040 - Characters on Self service page.Ex: Add more \xC0-\xFF AS ->  https://www.ascii-code.com (C0 -> FF)-->
                <input
                  id="first-name-check"
                  v-model="passenger_name"
                  pattern="[A-Za-z0-9 \-\xC0-\xFF]+"
                  type="text"
                  class="form-control w-100 text-uppercase"
                  required
                />
              </div>
              <div class="pt-3 pb-3">
                <div>
                  <p class="mb-3" v-html="textDes"></p>
                </div>
              </div>
              <div class="text-center pb-3 pt-3">
                <button type="submit" class="btnDefault btn-border-option" name="btnConfirm">
                  {{ textSubmit.toUpperCase() }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>
<script>
import 'vue-tel-input/dist/vue-tel-input.css'
import { replaceStr } from '@/utils/helper'
import Title from '@/components/Title/index'

export default {
  name: 'ConfirmVirtualHelpdesk',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      passenger_name: '',
      textSubmit: '',
      textDes: '',
      step: 0,
      confirmPax: false
    }
  },
  watch: {
    airline: function () {
      if (!_.isEmpty(this.pax)) {
        this.initData()
      }
    },
    pax: function () {
      if (!_.isEmpty(this.airline)) {
        this.initData()
      }
    }
  },
  beforeCreate: function () {
    this.$emit('changeLinkName', '')
  },
  created() {
    this.initData()
  },
  methods: {
    replaceStr,
    confirmName: function () {
      if (this.step) {
        this.$router.push({ path: '/home', query: { secret: this.secret } })
      }
      var self = this
      let dataSend = {
        first_name: self.passenger_name,
        phone_number: self.pax.phone_number
      }
      if (self.pax.amadeus_virtual_desk) {
        dataSend.amadeus_virtual_desk = self.pax.amadeus_virtual_desk
      } else {
        dataSend.pax_id = self.pax.id
      }
      self.$store.dispatch('ConfirmVirtualHelpdesk/confirm', dataSend).then(function (res) {
        if (res.success) {
          if (self.pax.amadeus_virtual_desk) {
            self.confirmPax = true
          } else {
            self.step = 1
            self.textDes = self.lang['virtual_helpdesk'].SFS_LANG_ROW_19 + '</br>' + self.lang['virtual_helpdesk'].SFS_LANG_ROW_20
            self.textSubmit = self.lang['virtual_helpdesk'].SFS_LANG_ROW_21
          }
        } else {
          self.textDes = self.lang['virtual_helpdesk'].SFS_LANG_ROW_22 + '</br>' + self.lang['virtual_helpdesk'].SFS_LANG_ROW_23
        }
      })
    },
    initData() {
      var self = this
      if (!_.isEmpty(self.pax)) {
        if (
          self.pax.params &&
          (_.isUndefined(self.pax.params.confirm_virtual_helpdesk) || self.pax.params.confirm_virtual_helpdesk === 1)
        ) {
          if (self.pax.amadeus_virtual_desk) {
            self.confirmPax = true
          } else {
            self.$router.push({ path: '/home', query: { secret: self.secret } })
          }
          return
        }
        this.textSubmit = this.lang['virtual_helpdesk'].SFS_LANG_ROW_12
      }
    }
  }
}
</script>
